export default class skipToContent {
    constructor() {
        let self = this;
        $('.skip-to-content').click(function (e){
            self._skipTo();
            e.preventDefault();
        });
        $(".skip-to-content").keyup(function (e){
            if(e.which == '13'){
                self._skipTo();
                e.preventDefault();
            }
        });
    }

    _skipTo(){
        $('[role="main"]').attr("tabindex",0).focus();
        $('html,body').animate({
            scrollTop: ($('[role="main"]').offset().top)
        });
    }
}